import { Button } from "@novaescola/eva-react-v2/lib/Button";
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import React, { useEffect, useRef, useState } from "react";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "../general/Image";
import Jhonata from '../../images/Jhonata.png'
import Marlucia from '../../images/Marlucia.png'
import Tatiane from '../../images/Tatiane.png'

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import PhoneModal from "./PhoneModal";

export function CarouselSection({ section, pageTitle, user }) {
	const colorArrow = section.body?.textColor === '#FFFFFF' || section.body?.textColor === '#ffffff' ? "arrow-color-white" : section.body?.textColor;
	const location = window.location.pathname;
	const validUrl = location === "/tudo-sobre/planos-de-aula-por-whatsapp/";
	const sectionRef = useRef(null);
	const [showModal, setShowModal] = useState(false)
	const [linkRedirect, setLinkRedirect] = useState("")
	const [name, setName] = useState("")
	const isComunidadeNE = location.includes("/comunidade-nova-escola/");
	const shouldHide = isComunidadeNE && section.order === 3;
	const mappingElement = (elements, position) => {
		if (!elements || !position) return;

		Array.from(elements).forEach((el) => 
			el.style.justifyContent = position
		);
	}

	useEffect(() => {
		if (!sectionRef.current) return;
		const swippers = sectionRef.current.getElementsByClassName('swiper-wrapper');
		
		if (swippers.length === 1 && section.body?.itens.length <= 3) {
			mappingElement(swippers, "center");
		} else {
			mappingElement(swippers, "flex-start");
		}
	}, []);

	const propsImage = (item) => {
		const isVertical = item?.verticalImage && !item?.horizontalImage;
		const shouldUseVerticalSize = isVertical || validUrl;

		return {
			width: shouldUseVerticalSize ? 263 : 267,
			height: shouldUseVerticalSize ? 265 : 150,
		};
	}
	return (
		<>
		<section ref={sectionRef} className="container-fluid" style={{ backgroundColor: section.body?.backgroundColor }}>
			<div className="container container-blocks">
				<Typography variant="title" size={4} asChild
					className="eva-margin-bottom-2" style={{ color: section.body?.textColor, textAlign: `${validUrl && 'center'}` }}>
					<p>{section.body?.title}</p>
				</Typography>

				<Typography variant="body" size={2} asChild
					className="eva-margin-bottom-2"
					style={{ color: section.body?.textColor, textAlign: `${validUrl && 'center'}` }}
				>
					<p>{section.body?.subtitle}</p>
				</Typography>

				<Swiper
					breakpoints={{
						320: {
							slidesPerView: 1.2,
						},
						480: {
							slidesPerView: 3,
						},
						640: {
							slidesPerView: 4,
						}
					}}
					slidesPerView={4}
					spaceBetween={15}
					navigation={section.body?.itens.length > 4}
					modules={[Navigation]}
					id={section.body?.title}
					className={`eva-react-carrossel eva-margin-bottom-4 ${colorArrow}`}
				>
					{section.body?.itens.map((itemCarousel, index) => {
						if (section.body?.title === "O que é Educação Baseada na Natureza?") {
							return (
								<SwiperSlide key={`item-${itemCarousel.title}`} id={`card-${section.body?.title}-${itemCarousel.index}`}>
									<div className="eva-card eva-bg-branco" style={{ minHeight: "288px" }}>
										<div className="eva-card-info">
											<Typography asChild className="eva-card-title eva-text-bold">
												<p>{itemCarousel.title}</p>
											</Typography>
											<Typography variant="body" size={3} asChild >
												<p>{itemCarousel.line}</p>
											</Typography>
										</div>
									</div>
								</SwiperSlide>
							)
						}
						return (
							<SwiperSlide 
								key={`item-${itemCarousel.title}`} 
								id={`card-${section.body?.title}-${itemCarousel.index}`}
							>
								<div className="eva-card eva-bg-branco">
									<a
										href={itemCarousel.contentUrl}
										data-track={`SITE: Click - ${pageTitle} - carrossel ${section.body?.title} - card ${index + 1}`}
									>
										<div 
											className="eva-card-img" 
											style={{ height: `${(itemCarousel?.verticalImage && !itemCarousel?.horizontalImage) || validUrl ? '265px' : '150px'}`}}
										>
											<Image
												className="card-img"
												{...propsImage(itemCarousel)}
												alt={itemCarousel?.altText || ""}
												remoteImage={itemCarousel?.remoteImage}
												fallbackImageUrl={itemCarousel?.imageUrl}
											/>
										</div>
									</a>
									<div className="eva-card-info" style={shouldHide ? { height: '100px' } : {}}>
										<Typography asChild className="eva-card-title eva-text-bold">
											<p>{itemCarousel.title}</p>
										</Typography>
										<Typography variant="body" size={3} asChild
											className="eva-card-description"
										>
											<p>{itemCarousel.line}</p>
										</Typography>
										{!shouldHide && (
											<Button fullWidth variant="primary" size="medium" asChild
												className="eva-margin-top-2"
												data-track={`SITE: Click - ${pageTitle} - carrossel ${section.body?.title} - card ${index + 1}`}
												style={{ width: '100%', cursor: 'pointer' }}
												onClick={async (e) => {
													if (itemCarousel.sendPdfWhatsappPrimaryButton) {
														e.preventDefault()
														setLinkRedirect(itemCarousel.contentUrl)
														setName(itemCarousel.title)
														setShowModal(true)
														return
													}
												}}
											>
												<a href={itemCarousel.sendPdfWhatsappPrimaryButton ? undefined : itemCarousel.contentUrl} target="_self" rel="noreferrer" type="button">
													{itemCarousel.textButton}
												</a>
											</Button>
										)}
									</div>
								</div>
							</SwiperSlide>
						)
					})}
				</Swiper>

			</div>
			{showModal && <PhoneModal user={user} linkRedirect={linkRedirect} onClose={() => setShowModal(false)} name={name} />}
			</section>
			{isComunidadeNE && section.order === 3 &&  (
				<section className="container-fluid">
						<section className="container blocks">
							<div className="testimonial container container-blocks">
								<div class="row">
								<div class="col-lg-4 col-md-4 col-sm-12">
									<div class="testimonial-homepage">
										<img src={Jhonata} alt="Jhonata" class="testimonial-image lazyload"/>
										<p class="eva-title-5 eva-margin-bottom-2">Jhonata Gomes, núcleo de Castro (PR)</p>
										<p class="eva-body-1">“Para mim, fazer parte da Conectando Saberes é <p className="eva-text-bold">me conectar com pessoas diferentes de mim, mas que tem um mesmo propósito e objetivo.</p> Para encontrar o caminho para uma educação pública de qualidade, a gente precisa estar conectado a outras pessoas que tem diferentes saberes mas que nos levam para esse objetivo.”</p>
									</div>
								</div>
								<div class="col-lg-4 col-md-4 col-sm-12">
									<div class="testimonial-homepage">
										<img src={Marlucia} alt="Marlúcia" class="testimonial-image lazyload"/>
										<p class="eva-title-5 eva-margin-bottom-2">Marlúcia Brandão, núcleo de Marataízes (ES)</p>
										<p class="eva-body-1"><p className="eva-text-bold">“Fazer parte da Conectando Saberes foi um divisor de água na minha vida docente.</p> Desde 2016 quando eu entrei, eu não me sinto mais só como professora, como gestora porque a gente tem um ponto de conexao em todo o Brasil. A gente descobre que cada um está se unindo a nossa docência, a nossa gestão para fazer acontecer algo grande que é a educação de qualidade”</p>
									</div>
								</div>
								<div class="col-lg-4 col-md-4 col-sm-12">
									<div class="testimonial-homepage">
										<img src={Tatiane} alt="Tatiane" class="testimonial-image lazyload"/>
										<p class="eva-title-5 eva-margin-bottom-2">Tatiane Poletto, núcleo de Assis (SP)</p>
										<p class="eva-body-1">“Para mim, fazer parte da Conectando Saberes é um mar de oportunidades, de crescimento, de partilha, de me conectar e de trocar experiências a todo o momento com professores do Brasil inteiro que tem ideias diferentes. <p className="eva-text-bold">Aprendo o tempo todo”</p></p>
									</div>
								</div>
								</div>
							</div>
						</section>
					<div className="container blocks" style={{marginBottom:'50px'}}>
							<Typography variant="title" size={4} asChild
					className="eva-margin-bottom-2" style={{ color: section.body?.textColor, textAlign: `${validUrl && 'center'}`}}>
							<p>Saiba em que territórios a Conectando Saberes está</p>
						</Typography>
						<iframe src="https://padlet.com/contatocs/comunidade-conectando-saberes-ma0rq4jmmae1rspb" height="600px" width="100%" title="description"></iframe>
					</div>
				</section>
			)}
	</>
	);
}
